module.controller('widgetCtrl', ['$scope', '$q', 'Session', '$state', '$http', '$rootScope', 'baseURI', 'WIDGETS', 'OPTIONAL_WIDGETS', '$stateParams', 'accountService', 'LimitsService', function ($scope, $q, Session, $state, $http, $rootScope, baseURI, WIDGETS, OPTIONAL_WIDGETS, $stateParams, accountService, LimitsService) {
  var user = Session.getUser();
  var cardTypeUrl= baseURI + 'card/type';
  var physicalUrl = baseURI + 'card/physical';
  var limitsUrl = baseURI + 'card/mcc/restrictions/' + encodeURIComponent($stateParams.username);
  var hasBanks;

  $scope.toggledFlipCard = false;
  $scope.loadingState = 'idle';
  $scope.copiedText = "-1";
  $scope.loadingBankLoadState = 'idle';

  function getBanks() {
    $http.get(baseURI + 'bank?Username=' + encodeURIComponent($stateParams.username), {cache: true}).then(function (resp){
      hasBanks = !!resp.data.Data;
    });
  }
  getBanks();

  function noRestriction(featureKey) {
    return !user.restrictions.hasOwnProperty(featureKey) || !user.restrictions[featureKey];
  }

  function isRestricted(featureKey) {
    return user.restrictions.hasOwnProperty(featureKey) && user.restrictions[featureKey];
  }

  $scope.navigate = function(widget) {
    var state = $scope.getStateLink(widget);
    var split = state.split('(');
    if (widget.params) {
      $state.go(split[0], widget.params);
      return;
    }

    $state.go(state);
  };


  function addSubCardWidget(subLimits) {
    // Check if CH can add subs
    if(subLimits && subLimits.count > 0 && noRestriction('SUB-ADD')){
      $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.addSubCard]);
    }
  }

  $scope.accounts = accountService.getAccounts() || [];
  // get accounts from account service
  accountService.initializeAccounts(function(err, accounts){
    if(!err && accounts.length){
      $scope.accounts = accounts;
      $scope.loading = false;
      $scope.account = accountService.getAccount($stateParams.username);
      $scope.state = $state.current.name;
      $scope.widgets = WIDGETS;

      // hide Card Restrictions widget if no limits for now
      $http.get(limitsUrl, {cache: true}).then(function(resp){
        if (resp.data.Data) {
          $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.cardLimits]);
        }
      });

      var accountType;
      if ($scope.account.gpr) {
        $scope.accountType = 'gpr';
      } else if ($scope.account.expense) {
        $scope.accountType = 'expense';
      } else if ($scope.account.incentive) {
        $scope.accountType = 'incentive';
      } else if ($scope.account.gift) {
        $scope.accountType = 'gift';
      }
      $scope.isMain = $scope.account.main;

      getOptionalWidgets();

      // Disable check load widget if the API is restricting for this user
      if (isRestricted('CHECK-LOAD')) {
        var checkLoadIndex = $scope.widgets.findIndex(function(w) {
          return w.state === 'member.home.rdc/load.step1';
        });
        $scope.widgets[checkLoadIndex].access = 'disabled';
      }

      var limits = Session.getLimits();
      // If limits haven't loaded yet, load them
      if (!limits) {
        LimitsService.getLimits().then(function(resp){
          limits = LimitsService.setLimits(resp.data.Data);
          addSubCardWidget(limits['SUB-CARDS']);
        });
      } else {
        addSubCardWidget(limits['SUB-CARDS']);
      }

      // Add brand widgets defined in brandData.json
      if (typeof $scope.brand.widgets !== 'undefined') {
        $scope.widgets = $scope.widgets.concat($scope.brand.widgets);
      }
    }

    $scope.getStateLink = function(widget){
      var state = widget.state;
      if (Session.getEnrollmentErrorCode() === 150){
        return 'member.home.profile/verification.step1';
      }
      if (widget.state === 'member.home.bank/transfer.step1({ transferType: "load" })' || widget.state === 'member.home.bank/manage.list' || widget.state === 'member.home.bank/transfer.step1({transferType:"withdraw"})') {
        if(!hasBanks){
          widget.params = { redirect: widget.state };
          if(widget.state.includes('load')){
            widget.params.transferType = 'load';
          } else if(widget.state.includes('withdraw')) {
            widget.params.transferType = 'withdraw';
          }
          state = 'member.home.bank/add.step1';
        }
      }

      return state;
    };
  });

  function checkVirtualWidgets(subCard) {
    $http.get(cardTypeUrl + '?Username=' + encodeURIComponent(subCard.username), {cache: true}).then(function (resp){
      $http.get(physicalUrl + '?Username=' + encodeURIComponent(subCard.username), {cache: true}).then(function (physicalDataResp){
        if (Session.getEnrollmentErrorCode() !== 150 && !resp.data.Data.PhysicalOrdered && physicalDataResp.data.Data.PhysicalProgram) {
          $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.sendPhysicalCard]);
        }
      }).catch(function (error){
        console.log('err', error);
      });
    }).catch(function (error){
      console.log('err', error);
    });
  }

  function getOptionalWidgets(){
    //re-route the user to the additional enrollment verification flow if their enrollment is incomplete
    if(Session.getEnrollmentErrorCode() === 150 && !Session.getIsFraudBlocked()){
      $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.verifyAccount]);
    }

    if($rootScope.hasMainAccess && Session.getEnrollmentErrorCode() !== 150) {
      $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.loadSubCard]);

      if ($scope.account.atmAccess !== 'invalid') {
        $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.atmAccess]);
      }
    }

    if($scope.account.virtual) {
      checkVirtualWidgets($scope.account);
    }

    if($scope.brand.name === 'uptogether'){
      $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.sendCheck]);
      $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.uptogetherManageBanks]);
      $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.uptogetherWithdraw]);
      $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.uptogetherManageTransfers]);
    } else {
      $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.manageBanks]);
      $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.withdraw]);

      if(noRestriction('SUB-LOAD')){
        $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.manageAutoTransfers]);
      }

      if ($scope.account.consumerChoice) {
        $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.achBank]);
        $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.sendCheck]);
        if (noRestriction('DBT-OUT')) {
          $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.debitCardWithdrawal]);
        }
        $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.paypalWithdraw]);
        $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.venmoWithdraw]);
      }
    }

    // check card's status
    switch($scope.account.statusCode){
      case '12':
        $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.activateCard]);
        break;
      case '10':
        $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.disableSub]);
        break;
      case '13':
        $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.enableSub]);
        break;
    }

    if(noRestriction('SUB-RETRIEVE')) {
      $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.retrieveFundsSub]);
    }

    if(noRestriction('SUB-CLOSE')) {
      $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.closeSub]);
    }

    // blocked notification widgets
    if ($scope.account.main) {
      if(Session.getIsLoadBlocked()){
        $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.loadBlock]);
      }

      if(Session.getIsFraudBlocked()){
        $scope.widgets = $scope.widgets.concat([OPTIONAL_WIDGETS.fraudBlock]);
      }
    }
  }

}]);
